<template>
  <div v-resize="setContentHeight">
    <div>
      <!-- Toolbar -->
      <v-toolbar dark color="primary" class="pr-1">
        <v-btn icon @click="goBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title>My Booking Details</v-toolbar-title>
      </v-toolbar>

      <div
        v-if="booking && accountInfo && settings"
        ref="myBookingDetailsScrollable"
        class="scrollable"
      >
        <v-card
          flat
          style="
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            height: 100%;
          "
        >
          <v-img
            :src="
              booking.pax
                ? `${branchImagePath}${booking.branchImageUrls[0]}`
                : `${areaImagePath}${booking.areaImageUrls[0]}`
            "
            max-height="154"
          ></v-img>

          <div class="pa-4 text-small">
            <!-- Booking details -->
            <div class="font-weight-bold mb-1 text-title-black">
              {{
                booking.pax
                  ? "Library Visit"
                  : formatLocation(booking.area, booking.seat, booking.floor)
              }}
            </div>
            <div
              v-if="booking.areaIgnoreHolidays"
              class="subtitle font-weight-bold mb-2"
              style="font-sizex: initial"
            >
              Extended hours zone – available on Public Holidays
            </div>
            <div>
              <v-row v-if="booking.pax" dense>
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-account-multiple</v-icon>
                </v-col>
                <v-col>{{ booking.pax }}</v-col>
              </v-row>
              <v-row v-else dense>
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-seat</v-icon>
                </v-col>
                <v-col>{{ booking.seat }}</v-col>
              </v-row>

              <v-row dense>
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-counter</v-icon>
                  <!-- mdi-format-list-numbered -->
                  <!-- mdi-counter -->
                  <!-- mdi-fingerprint -->
                  <!-- music-accidental-sharp -->
                </v-col>
                <v-col>{{ booking.bookingRefId }}</v-col>
              </v-row>

              <v-row dense>
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-library</v-icon>
                </v-col>
                <v-col>{{ booking.branchName }}</v-col>
              </v-row>

              <v-row dense>
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-calendar-month</v-icon>
                </v-col>
                <v-col>{{ formatDate(booking.startTime) }}</v-col>
              </v-row>

              <v-row dense>
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-clock-outline</v-icon>
                  <!-- <v-icon class="icon-small">{{
                  booking.pax ? "mdi-human-handsdown" : "mdi-seat"
                }}</v-icon> -->
                </v-col>
                <v-col>
                  {{ formatPeriod(booking.startTime, booking.endTime) }}
                </v-col>
              </v-row>

              <v-row dense v-if="booking.areaInformation && booking.areaInformation.directionalInfo">
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-directions</v-icon>
                </v-col>
                <v-col>{{ booking.areaInformation.directionalInfo }}</v-col>
              </v-row>

              <v-row dense>
                <v-col class="col-1">
                  <v-icon
                    :color="
                      formatBookingStatus(booking.actions, booking.pax).color
                    "
                    class="icon-small"
                    >{{
                      formatBookingStatus(booking.actions, booking.pax).icon
                    }}</v-icon
                  >
                </v-col>
                <v-col class="text-uppercasex">{{
                  formatBookingStatus(booking.actions, booking.pax).text
                }}</v-col>
              </v-row>

              <!-- <v-row v-if="windowSettings.showBloombergEndingSoonInfo && (booking.area == 'Bloomberg Terminal')" dense>
                <v-col class="col-1">
                  <v-icon class="icon-small">mdi-information-outline</v-icon>
                </v-col>
                <v-col>
                  We are sorry that this database will not be available from 27 October 2021. If you have any queries, please send an email to our Customer Relations Officer at <a href='mailto: enquiry@nlb.gov.sg'>enquiry@nlb.gov.sg</a>
                </v-col>
              </v-row> -->
            </div>

            <!-- Action buttons -->
            <div class="button-group mt-4">
              <!-- View map button -->
              <v-row v-if="!booking.pax">
                <v-col>
                  <v-btn
                    @click="viewMaps(booking)"
                    dark
                    large
                    color="primary"
                    class="px-5"
                    block
                  >
                    <v-icon left dark>mdi-map-search</v-icon>View Maps
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Cancel button -->
              <v-row v-if="canCancelNow && !(this.booking.bookingRefId.includes('S') && isEmailMobileLogin)">
                <v-col>
                  <v-btn
                    @click="confirmCancelBooking(booking)"
                    dark
                    large
                    color="orange"
                    block
                  >
                    <v-icon left dark>mdi-close-thick</v-icon>Cancel Booking
                  </v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  v-if="
                    !windowSettings.disableExtension &&
                    !booking.pax &&
                    canExtendNow
                  "
                >
                  <v-btn
                    @click="extend(booking)"
                    dark
                    large
                    color="orange"
                    block
                  >
                    <v-icon left dark>mdi-expand-all</v-icon>Extend If Available
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>

        <!-- Cancellation confirmation popup -->
        <v-row justify="center">
          <v-dialog v-model="confirmDialog.show" max-width="400">
            <v-card class="py-2">
              <v-card-title class="mb-3">{{
                confirmDialog.message
              }}</v-card-title>

              <div @click="InputPopupSelectCancelReason.show = true">
                <v-text-field
                  placeholder="Reason for cancellation"
                  :value="
                    InputPopupSelectCancelReason.selectedItem
                      ? InputPopupSelectCancelReason.selectedItem.name
                      : ''
                  "
                  class="px-8"
                  readonly
                ></v-text-field>

                <InputPopupSelect
                  title="Reason for cancellation"
                  :list="
                    booking.pax
                      ? settings.menus.visitBookingCancelReasons
                      : settings.menus.cancelReasons
                  "
                  :select.sync="InputPopupSelectCancelReason"
                />
              </div>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="confirmDialog.show = false"
                  >No</v-btn
                >

                <v-btn
                  :disabled="!InputPopupSelectCancelReason.selectedItem"
                  color="primary"
                  text
                  @click="
                    cancel(
                      booking,
                      InputPopupSelectCancelReason.selectedItem.code
                    )
                  "
                  >Yes</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import formatters from "@/helpers/formatters";
import validators from "@/helpers/validators";
import apiHelper from "@/helpers/apiHelper";
import InputPopupSelect from "@/components/InputPopupSelect";

import businessLogic from "@/helpers/businessLogic";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "MyBookingDetails",
  components: { InputPopupSelect },
  data: () => ({
    booking: null,
    confirmDialog: {
      show: false,
      message: "",
    },
    InputPopupSelectCancelReason: {
      show: false,
      selectedItem: null,
    },
  }),
  computed: {
    ...mapState(["qrCode", "selectedBooking"]),
    ...mapGetters(["mode", "isEmailMobileLogin"]),
    canCancelNow() {
      return this.booking.pax
        ? validators.canCancelVisit(
            this.booking.canCancelStatus,
            this.booking.startTime,
            this.time.nowMoment
          )
        : validators.canCancel(
            this.booking.canCancelStatus,
            this.booking.endTime,
            this.booking.bookingTimeslotInMinutes,
            this.time.nowMoment
          );
    },
    canExtendNow() {
      return validators.canExtend(
        this.booking.canExtendStatus,
        this.booking.endTime,
        this.settings.system.extensionStartTimeInMinutes,
        this.settings.system.extensionEndTimeInMinutes,
        this.time.nowMoment
      );
    },
  },
  methods: {
    ...mapMutations(["updateLocationInfoFromQrCode"]),
    viewMaps(booking) {
      this.$router.push({
        name: "ViewMaps",
        params: {
          mapFileNames: booking.mapUrls,
        },
      });
    },
    formatLocation(area, seat, floor) {
      return formatters.formatLocation(area, seat, floor);
    },
    formatPeriod(fromDateString, toDateString) {
      return formatters.formatPeriod(fromDateString, toDateString);
    },
    formatDate(dateString) {
      return formatters.formatDate(dateString);
    },
    formatBookingStatus(actions, isVisitBooking) {
      return formatters.formatBookingStatus(actions, isVisitBooking);
    },
    async checkIn(booking) {
      const response = await apiHelper.checkIn(
        booking.bookingId,
        false,
        booking.branchId
      );

      this.commonResponseHandler(
        response,
        window.$msg.checkInSuccess,
        window.$msg.checkInFail,
        () => this.goBack()
      );
    },
    async extend(booking) {
      //Check if it's in onsiteMode, if not, redirect to ScanQRCode
      if (!this.onsiteMode || this.mode.branchId !== this.booking.branchId) {
        this.$router.push({ name: "ScanQRCode", params: { state: "extend" } });
        return;
      }

      const response = await apiHelper.extend(
        booking.bookingId,
        booking.branchId
      );

      this.commonResponseHandler(
        response,
        window.$msg.extendSuccess,
        window.$msg.extendFail,
        () => this.goBack()
      );
    },
    confirmCancelBooking() {
      this.confirmDialog.message = window.$msg.confirmCancel;
      this.confirmDialog.show = true;
    },
    async cancel(booking, cancelReasonCode) {
      this.confirmDialog = {
        show: false,
        message: "",
      };

      const response = await apiHelper.cancel(
        booking.pax,
        booking.bookingId,
        cancelReasonCode,
        booking.branchId
      );

      this.commonResponseHandler(
        response,
        window.$msg.cancelSuccess,
        window.$msg.cancelFail,
        () => this.goBack()
      );
    },
    setContentHeight() {
      if (this.$refs.myBookingDetailsScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.myBookingDetailsScrollable.style.height =
          contentHeight + "px";
      }
    },
  },
  watch: {
    qrCode(newValue, oldValue) {
      if (newValue) {
        if (newValue.state === "extend") {
          //Update locationInfoFromQrCode
          const locationInfo = businessLogic.getLocationInfoFromQrCode(
            newValue.value,
            this.settings.menus.branchMenus
          );

          if (locationInfo) {
            this.updateLocationInfoFromQrCode(locationInfo);

            //Check onsiteMode & extend if really onsite
            this.$nextTick(() => {
              if (
                this.onsiteMode &&
                this.mode.branchId === this.booking.branchId
              ) {
                this.extend(this.booking);
              } else {
                const msg = window.$msg.extendAtTheWrongBranch;

                this.updateSystemDialog({
                  show: true,
                  title: window.$msg.extendFail,
                  message: msg,
                });
              }
            });
          } else {
            this.updateSystemDialog({
              title: window.$msg.invalidQrCodeTitle,
              message: window.$msg.invalidQrCodeMsg,
            });
          }
        }
      }
    },
    "confirmDialog.show"(newValue, oldValue) {
      this.InputPopupSelectCancelReason.selectedItem = null;
    },
  },
  activated() {
    this.booking = this.selectedBooking;

    this.$nextTick(() => this.setContentHeight());
  },
  beforeRouteLeave(to, from, next) {
    const inputs = [this.InputPopupSelectCancelReason, this.confirmDialog];

    for (let i of inputs) {
      if (i != null && i.show) {
        i.show = false;

        next(false);
        return;
      }
    }

    next();
  },
};
</script>

<style scoped>
.button-group .col {
  margin: 5px;
  padding: 0px;
}
</style>
